'use strict';

import errorTemplate from './error.html';

var errorController = function($window, $state) {
    var vm = this;
    vm.myErrorMessage = $state.params.myErrorMessage;

    vm.$onInit = function() {
        $window.onbeforeunload = null;
    }
}

errorController.$inject = [ '$window', '$state' ];

export var errorComponent = {
    name: 'error',
    template: errorTemplate,
    controller: errorController,
    controllerAs: 'vm'
}

export var errorRoute = {
    name: 'error',
    url: '/error',
    component: 'error',
    params:{myErrorMessage: null}
}